"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductMenuContent = void 0;
exports.ProductMenuContent = {
  en: {
    metalHelpText1: "Help me find",
    metalHelpText2: "the right metal"
  },
  fr: {
    metalHelpText1: "Aide-moi à trouver",
    metalHelpText2: "le bon métal"
  },
  es: {
    metalHelpText1: "Ayúdame a encontrar",
    metalHelpText2: "el metal correcto"
  }
};